<template>
    <div class='workTop-panel'>
        <div class="wthead-panel" v-if="signConfig[columnIndex].type === 'mv'">
            <a class="wthead-tab" href="javascript:;" v-bind:class="{' wthead-select': order == 4 }"  v-on:click="order = 4">最热视频</a>            
            <a class="separator" href="javascript:;">/</a> 
            <a class="wthead-tab " href="javascript:;" v-bind:class="{' wthead-select': order == 1 }"  v-on:click="order = 1">最新视频</a> 
            <a href="javascript:void(0);" class='wthead-more' v-on:click="getMore">更多作品 &gt; &gt;</a>
        </div>
        <div class="wthead-panel" v-else >
            <a class="wthead-tab" href="javascript:;" v-bind:class="{' wthead-select': order == 3 }"  v-on:click="order = 3">最热作品</a>            
            <a class="separator" href="javascript:;">/</a> 
            <a class="wthead-tab " href="javascript:;" v-bind:class="{' wthead-select': order == 1 }"  v-on:click="order = 1">最新作品</a> 
            <a href="javascript:void(0);" class='wthead-more' v-on:click="getMore">更多作品 &gt; &gt;</a>
        </div>
        <div class='wtcontent-panel' v-if='workList.length > 0'>
            <div class='wtcontent-warpper'>
                <ul class='wtcontent-list' v-bind:class="{'mv-ul': columnIndex == 1 }" v-bind:style="{ 'margin-left' : -(currentPage-1)*953+'px' }">
                    <li  v-for="item in workList" >
                        <workItem :columnIndex="columnIndex" :work="item"></workItem>
                    </li>
                </ul>
            </div>
            <a class="prev-btn" href="javascript:;" v-show="currentPage > 1"  v-on:click="prevPage"></a> 
            <a class="next-btn" href="javascript:;" v-show="currentPage < maxPage"  v-on:click="nextPage"></a>
        </div>
        <div class="wtcontent-panel" v-else>
            <p class="blank-tips">比赛尚未有作品投稿，快去上传自己的作品，报名参加吧！</p>
        </div>
    </div>
</template>
<script>
import workItem from '@/components/work-item'
export default {
    name: 'workTop',
    data () {
        return {
            signConfig: this.$winConfig.signConfig,
            columnIndex: this.selfIdx||0,
            order: 3,
            workList: [],
            currentPage: 1,
            maxPage: 5,
        }
    },
    props:{
        selfIdx: Number,
        workType: String
    },
    components: {
        workItem
    },
    created: function () {
        if(this.selfIdx){
            this.order = 4;
           // this.columnIndex = this.selfIdx;
        }else{
            this.getList();
        }
        
    },
    watch: {
        order: function (val, oldVal) {
            this.getList();
            
        }
    },
    methods: {
        getMore: function(){
            this.$router.replace({
                name: 'indexWork',
                path: '/work',
                params: {
                    scroll: 1000,
                }
            })
        },
        prevPage: function(){
            if(this.currentPage > 1){
                this.currentPage--;
            }
        },
        nextPage: function(){
            if(this.currentPage < this.maxPage){
                this.currentPage++;
            }
        },
         /**
         * 列表请求。
         * @param {object} formData         请求参数
         * @param {string} ADD_WORK_URL     请求地址
         */
        getList: function(){
            var _this = this;
            var formData;
            var dataPage;
            if(this.columnIndex == 0){
                formData = {
                    sid: _this.signConfig[this.columnIndex].id,
                    page: 1,
                    order: _this.order,
                    number: 15,
                };
                dataPage = 5;
            }else  if(this.columnIndex == 1){
                formData = {
                    sid: _this.signConfig[this.columnIndex].id,
                    page: 1,
                    order: _this.order,
                    number: 8,
                    sign_type: 7
                };
                dataPage = 8;
            }
            this.$server.getWorkList(formData).then(function(res){
                _this.workList = res.data;
                _this.maxPage = res.data.length/dataPage;
            });
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
@import "../assets/sass/cmn.scss";
.wthead-panel{
    position: relative;
    margin-bottom: 20px;
    text-align: center;
    font-size: 18px;
    .separator{
        display: inline-block;
        padding: 5px 0;
        font-size: 26px;
        color: #e1d5f4;
        vertical-align: middle;
    }
    .wthead-tab{
        display: inline-block;
        padding:  10px;
        margin: 0 15px;
        color: #e1d5f4;
        vertical-align: top;
    }
    .wthead-select{
        color: #fff;
        border-bottom: 3px solid #fff;
    }
    .wthead-more{ 
        position: absolute;
        right: 0;
        top: 30%;
        display: block;
        color: #fff;
        font-size: 14px;
    }
}
.wtcontent-panel{
    position: relative;
    .wtcontent-warpper{
        overflow: hidden;
        .wtcontent-list{
            //width: 960px;
            width: 10000000px;
            transition: margin 500ms;
            li{
                display: inline-block;
                margin: 0 31px 20px 0;
            }
            
        }
        .mv-ul{
            width: 950px;
            li{
                margin: 0 23px 20px 0;
            }
        }
    }
    .prev-btn,.next-btn {
        position: absolute;
        top: 50%;
        display: none;
        width: 65px;
        height: 129px;
        margin-top: -100px;
        background-image: url(componentsImgPath('work/24.png'));
    }
    .prev-btn
    {
        left: -20px;
        background-position: 0 0;
    }
     .next-btn
    {
        right: -20px;
        background-position: -65px 0;
    }
    &:hover{
        .prev-btn,.next-btn {
            display: block;
        }
    }
    .blank-tips{
        line-height: 40;
        text-align: center;
    }
}

</style>




// WEBPACK FOOTER //
// src/components/work-top.vue